import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import moment from "moment";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { ArrowForward, PlayCircle, PauseCircle, Circle, ShowChart, CalendarMonth, Settings, Edit, Launch, OpenInBrowser } from "@mui/icons-material";

import { twoDatesRelative } from "helper/formatting";
import SoftButton from "components/SoftButton";
import { Button } from "@mui/material";

const PropTypes = require("prop-types");



function EventList({ events, editSelectedEvent, openSelectedEvent }) {

    events = events.sort(function (a, b) {
        if (a.start_time < b.start_time) {
            return 1;
        }
        else if (a.start_time > b.start_time) {
            return -1;
        }
        else {
            return 0;
        }
    })


    function createEventRows(title, events, isLive = false, canClick = true) {

        console.log(canClick)

        return (
            <SoftBox mb={5}>
                <SoftBox mb={2}>
                    <SoftTypography variant="h5">{title}</SoftTypography>
                </SoftBox>
                <Grid container spacing={3}>
                    {
                        events.map(function (event, index) {
                            return (
                                <Grid item xs={12} md={6} lg={6} xl={6} key={index} onClick={() => { event.event_id }} >
                                    {createEventCard(event, isLive, canClick)}
                                </Grid>
                            )
                        })
                    }
                </Grid>
            </SoftBox>);

    }

    function createEventCard(event, isLive, canClick) {
        
        return (
            <Card sx={{
                backgroundColor: 'white',
                transition: 'background-color 0.3s ease', // Smooth transition for hover effect
                '&:hover': canClick ? {
                    backgroundColor: 'lightgray', // Change background on hover
                    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)', // Add a subtle shadow
                } : {},
                cursor: canClick ? 'pointer' : ''
            }} onClick={() => { if (canClick) { openSelectedEvent(event) } }} >
                <SoftBox p={2}>
                    <SoftBox display="flex" alignItems="center">
                        <SoftBox lineHeight={0}>
                            <SoftBox mb={1} lineHeight={0}>
                                <SoftTypography></SoftTypography>
                                <SoftTypography variant="h6">{event.name} </SoftTypography>
                                <SoftTypography variant="body1">{twoDatesRelative(event.start_time, event.end_time, Date.now())}</SoftTypography>
                            </SoftBox>
                        </SoftBox>
                        {/* <Button sx={{color: "#000"}} endIcon={<Edit/>} onClick={() => editSelectedEvent(event)} /> */}
                        {/* <Button sx={{color: "#000"}} endIcon={<OpenInBrowser/>} onClick={() => openSelectedEvent(event)} /> */}
                        {isLive && <Circle sx={{ color: "red", marginLeft: 'auto' }} />}
                    </SoftBox>
                </SoftBox>
            </Card>
        );
    }

    const now = moment();


    let upcoming = events.filter((event) => {
        console.log(event)
        return moment(event.start_time).isAfter(now)
    });

    let liveEvents = events.filter((event) => {
        return moment(event.start_time).isBefore(now) && moment(event.end_time).isAfter(now)
    });

    let lastWeek = events.filter((event) => {
        return moment(event.end_time).isBefore(now) && moment(event.end_time).isAfter(now.clone().subtract(1, 'week'));
    });

    let lastMonth = events.filter((event) => {
        return moment(event.end_time).isBefore(now.clone().subtract(1, 'week')) && moment(event.end_time).isAfter(now.clone().subtract(1, 'month'));
    });

    let older = events.filter((event) => {
        return moment(event.end_time).isBefore(now.clone().subtract(1, 'month'))
    });

    upcoming = upcoming.length ? createEventRows('Upcoming', upcoming, false, false) : "";
    liveEvents = liveEvents.length ? createEventRows('Live Now', liveEvents, true) : "";
    lastWeek = lastWeek.length ? createEventRows('Last 7 Days', lastWeek) : "";
    lastMonth = lastMonth.length ? createEventRows('In the Last Month', lastMonth) : "";
    older = older.length ? createEventRows('Older', older) : "";

    return (
        <SoftBox>

            <SoftTypography variant="h5">Events</SoftTypography>
            {upcoming}
            {liveEvents}
            {lastWeek}
            {lastMonth}
            {older}
        </SoftBox>
    )
}

EventList.propTypes = {
    events: PropTypes.array,
    setScheduledEvent: PropTypes.func
}

export default EventList;